import STATE_TYPE from '@/constants/ConstantStateType';
import currency from 'currency.js';

export default class UtilsMask {
  // Formato: SS.SSS.SSS/SSSS-NN
  // N = número
  // S = letra ou número
  static cnpj(value) {
    if (!value) return '';

    // Remove os caracteres que não são letras ou números
    const v = value.toUpperCase().replace(/[^A-Z0-9]/g, '');

    // Começa com os 2 primeiros caracteres (SS)
    let out = v.slice(0, 2);

    // Se houver mais de 2 caracteres, adiciona o primeiro ponto (SS.SSS)
    if (v.length > 2) out += '.' + v.slice(2, 5);

    // Se houver mais de 5 caracteres, adiciona o segundo ponto (SS.SSS.SSS)
    if (v.length > 5) out += '.' + v.slice(5, 8);

    // Se houver mais de 8 caracteres, adiciona a barra (SS.SSS.SSS/SSSS)
    if (v.length > 8) out += '/' + v.slice(8, 12);

    // Se houver mais de 12 caracteres, adiciona o hífen (SS.SSS.SSS/SSSS-NN)
    if (v.length > 12) out += '-' + v.slice(12, 14);

    return out;
  }

  // Formato: SS.SSS.SSS
  // S = letra ou número
  static rootCnpj(value) {
    if (!value) return '';

    // Remove os caracteres que não são letras ou números
    const v = value
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .slice(0, 8);

    // Começa com os 2 primeiros caracteres (SS)
    let out = v.slice(0, 2);

    // Se houver mais de 2 caracteres, adiciona o primeiro ponto (SS.SSS)
    if (v.length > 2) out += '.' + v.slice(2, 5);

    // Se houver mais de 5 caracteres, adiciona o segundo ponto (SS.SSS.SSS)
    if (v.length > 5) out += '.' + v.slice(5, 8);

    return out;
  }

  static cpf(value) {
    if (!value) return '';

    value = value.toString();

    if (value.length === 11) return value.replace(/\D/g, '').replace(/^(\d{3})(\d{3})?(\d{3})?(\d{2})?/, '$1.$2.$3-$4');

    return value;
  }

  static cnae(value) {
    if (!value) return '';

    value = value.toString();

    if (value.length === 3) return value.replace(/\D/g, '').replace(/^(\d{2})(\d{1})?/, '$1.$2');
    if (value.length === 5) return value.replace(/\D/g, '').replace(/^(\d{2})(\d{2})?(\d{1})?/, '$1.$2-$3');
    if (value.length === 7) return value.replace(/\D/g, '').replace(/^(\d{4})(\d{1})?(\d{2})?/, '$1-$2/$3');

    return value;
  }

  static cep(value) {
    if (!value) return '';

    if (value.length === 8) return value.replace(/\D/g, '').replace(/^(\d{5})(\d{3})?/, '$1-$2');

    return value;
  }

  static money(value, precision = 2, symbol = 'R$ ', defaultValue = 'R$ 0,00') {
    if (!value) return defaultValue;

    try {
      return currency(value, { symbol, separator: '.', decimal: ',', precision }).format();
    } catch (e) {
      return value;
    }
  }

  static empty(value) {
    if (!value) return '---';

    return value;
  }

  static statusType(value) {
    if (!value) return value;

    return STATE_TYPE[value] ?? value;
  }
}
